export function getDateRange(type) {
  const today = new Date();

  const formatDate = (date) => {
    return date.toISOString().split("T")[0];
  };

  let dateFrom = "";
  let dateTo = formatDate(today);

  switch (type) {
    case "today":
      dateFrom = formatDate(today);
      break;

    case "yesterday": {
      const yesterday = new Date();
      yesterday.setDate(today.getDate() - 1);

      dateFrom = formatDate(yesterday);
      dateTo = formatDate(yesterday);
      break;
    }

    case "7days": {
      const last7Days = new Date();
      last7Days.setDate(today.getDate() - 6);

      dateFrom = formatDate(last7Days);
      break;
    }

    case "30days": {
      const last30Days = new Date();
      last30Days.setDate(today.getDate() - 29);

      dateFrom = formatDate(last30Days);
      break;
    }

    default:
      dateFrom = formatDate(today);
  }

  return {
    dateFrom,
    dateTo,
  };
}